import { $t } from '@/plugins/fluent';
import { z } from 'zod';

export const LinkSchema = z
    .object({
        id: z.string(),
        name: z.string(),
        to: z.string(),
        description: z.string(),
        status: z.enum(['create', 'delete', 'update', 'skip']),
    })
    .superRefine((link, ctx) => {
        // Unchanged server data, or being removed on save — nothing to validate
        if (link.status === 'skip' || link.status === 'delete') {
            return;
        }

        // Fresh, untouched placeholder row — exempt until something is typed
        const isEmptyPlaceholder =
            link.status === 'create' && link.name.length === 0 && link.to.length === 0 && link.description.length === 0;

        if (isEmptyPlaceholder) {
            return;
        }

        if (link.name.length === 0) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: $t('input-required'),
                path: ['name'],
            });
        }

        if (link.to.length === 0) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: $t('input-required'),
                path: ['to'],
            });
        }
    });

export type LinkSchemaType = z.infer<typeof LinkSchema>;
